import Collector from './collector'
import PlayStatistic from './play'
import CDNStatistic from './cdn'
import DanmuStatistic from './danmu'
import TafStatistic from './taf'

class Statistic {
  constructor(player) {
    this.collector = this.getCollector(player)
    new PlayStatistic(this.collector)
    new CDNStatistic(this.collector)
    new DanmuStatistic(this.collector)
    new TafStatistic(this.collector)
  }
  getCollector(player) {
    return new Collector(player)
  }
}

export default Statistic
